export enum Rooms {
	Foyer = 'Foyer',
	BadBoysTable = 'Bad Boys Table',
	Dining = 'Dining Room',
	Living = 'Living Room',
	TV = 'TV Room',
}
